import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	documentIconContainer: {
		width: "40px",
		height: "40px",
		borderRadius: "10px",
		backgroundColor: themeColors.colors.system.purple[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: themeColors.colors.system.purple[600]
	},
	sectionTitle: {
		fontSize: "1rem",
		fontWeight: 600,
		color: themeColors.colors.system.gray[900]
	},
	sectionSubtitle: {
		fontSize: "0.875rem",
		color: themeColors.colors.system.gray[500]
	},
	closerFieldLabel: {
		fontSize: "0.8125rem",
		fontWeight: 700,
		color: themeColors.colors.system.gray[900]
	},
	closerSelectControl: {
		width: "300px"
	},
	transcriptionTextarea: {
		fontFamily: "monospace"
	},
	counterText: {
		fontSize: "0.75rem",
		color: themeColors.colors.system.gray[500]
	},
	counterTextAtLimit: {
		fontSize: "0.75rem",
		color: themeColors.colors.error[600],
		fontWeight: 600
	},
	errorContainer: {
		padding: "16px",
		borderRadius: "8px",
		backgroundColor: themeColors.colors.error[50],
		border: `1px solid ${themeColors.colors.error[200]}`,
		display: "flex",
		alignItems: "flex-start",
		gap: "8px"
	},
	errorText: {
		fontSize: "0.875rem",
		color: themeColors.colors.error[700]
	},
	retryButton: {
		color: themeColors.colors.system.purple[600],
		fontWeight: 600,
		fontSize: "0.875rem",
		textTransform: "none"
	},
	saveButton: {
		backgroundColor: themeColors.colors.system.purple[600],
		color: themeColors.colors.base.white,
		textTransform: "none",
		fontWeight: 600,
		borderRadius: "8px",
		height: "40px",
		padding: "8px 24px",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[700]
		},
		"&:disabled": {
			backgroundColor: themeColors.colors.system.gray[200],
			color: themeColors.colors.system.gray[500]
		}
	}
}))

export default useStyles
